import React from 'react';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import { _ } from '_locales';
import { colors } from '_styles';

const Label = styled.label`
  display: flex;
  justify-content: center;
  margin: 25px 0;
  font-weight: 400 !important;
  font-size: 14px !important;
`;

const Checkbox = styled.input`
  transform:scale(1.5);
  margin-right: 10px;
  accent-color: ${colors.RC_ACTION};
`;

// End style

const SubscribeToNotifications = () => {
  const { register } = useFormContext();
  return (
    <Label>
      <Checkbox
        type="checkbox"
        id="checkbox-subscribe"
        name="subscribe_to_notifications"
        ref={register}
      />
      {_('reminder.subscribe_to_your_municipality_notifications')}
    </Label>

  );
};

export default SubscribeToNotifications;
